import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Raw "Superfood" salads',
    description: 'Like kale or broccoli contain tough fibers that act like a mechanical stressor, creating more gas in an already sensitive gut.'
  }, {
    title: 'Juice cleanses',
    description: 'Spike your insulin and often cause "rebound" water retention the moment you stop.'
  }, {
    title: 'Over-the-counter laxatives',
    description: 'Irritate the gut lining and trigger an inflammatory "swelling" response.'
  }, {
    title: 'Drinking plain water',
    description: 'Without the correct electrolyte ratio actually dilutes your system, causing your body to hold onto its remaining fluid even tighter.'
  }];
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-19">
      <FadeIn data-id="element-20">
        <h3 className="text-sm font-sans font-bold tracking-widest text-terracotta uppercase mb-4 text-center" data-id="element-21">
          The Trap
        </h3>
        <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-12 text-center leading-tight" data-id="element-22">
          Why what you tried didn't work
        </h2>

        <div className="space-y-6" data-id="element-23">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-24">
              <div className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-cream-dark" data-id="element-25">
                <div className="flex-shrink-0 mt-1" data-id="element-26">
                  <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-27">
                    <X className="w-5 h-5 text-red-400" data-id="element-28" />
                  </div>
                </div>
                <div data-id="element-29">
                  <h4 className="font-sans font-semibold text-charcoal mb-1" data-id="element-30">
                    {item.title}
                  </h4>
                  <p className="text-charcoal-light font-sans leading-relaxed text-sm md:text-base" data-id="element-31">
                    {item.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </section>;
}